export interface LabelValue {
  label: string;
  value: number;
}

// Combines slices smaller than 3% of the total into a single "Other" segment,
// while always keeping at least two named segments visible.
export function groupSmallSegments<T extends LabelValue>(data: T[]): LabelValue[] {
  return splitSmallSegments(data).main;
}

// Same grouping, but also returns the slices folded into "Other" (for drill-down).
export function splitSmallSegments<T extends LabelValue>(
  data: T[]
): { main: LabelValue[]; small: LabelValue[] } {
  const total = data.reduce((s, v) => s + v.value, 0);
  if (total === 0) return { main: data, small: [] };
  const main: LabelValue[] = [];
  const small: LabelValue[] = [];
  for (const d of data) {
    if (d.value / total < 0.03 && main.length + small.length < data.length - 2) {
      small.push({ label: d.label || 'Unknown', value: d.value });
    } else {
      main.push({ label: d.label || 'Unknown', value: d.value });
    }
  }
  if (small.length > 0) {
    main.push({ label: 'Other', value: small.reduce((s, v) => s + v.value, 0) });
  }
  return { main, small };
}
